/* eslint-disable indent */
import * as yup from 'yup'

class ValidationService {

    ticket = yup.object({
        Type: yup.string().required().nullable().label('Type').min(1, 'Select at least one Type'),
        Category: yup.string().nullable().required().label('Category').min(1, 'Select at least one Category'),
        Subject: yup.string().nullable().required().max(400).label('Subject'),
        Description: yup.string().nullable().max(2000, 'Word limit exceeded, max 2000').label('Description'),

    })

}
export default new ValidationService()